import { FilterOperation } from '../filter/filter-criteria';
import { IrdValidator } from './validator';

//?? is there a better solution to convert the type to strings
export type IrdPropertyType = 'number' | 'string' | 'boolean' | 'Date' | 'Object' | 'select' | 'enum' | 'icon' | 'color' | 'json';

/** Turns a raw value into the one a form edits. A plain function: this library stays free of Angular. */
export type IrdParser = (value: never) => string | number | boolean | null | undefined;

//binding name against record key in properties?
/**
 * T = Representing DAO (or other class)
 * O = type of value
 */
/** An option offered by a filter field. `values` is for json keys only: what to offer once that key is picked. */
export interface FilterOption {
  value: string;
  label: string;
  values?: FilterOption[];
}

export interface IrdProperty<T, O> {
  name: keyof T;
  //metadata: Metadata<T>; nice2Have
  type: IrdPropertyType;

  /**
   * The name the backend knows this field by, when it differs from {@link name}.
   *
   * Declared in exactly one place and read by both the sort resolution and the object mappers,
   * so a rename cannot drift between the two. Left undefined when both names agree.
   */
  daoName?: string;

  //array or map => map direct access e.g. to required. array order or validation
  validator: IrdValidator[];
  asyncValidator: IrdValidator[]; //?? IrdAsyncValidator

  parser?: IrdParser;
  //component: //TODO visual representation e.g. AlertLevel ERROR to icon (what about color picker / show color / edit color)
  showInUi: boolean;
  array: boolean;
  /**
   * Whether the field may be changed — in the edit dialog and, where the table switches inline
   * editing on, in its cell. The default for every view; a form or table declaration may override it
   * per property (`IrdPropertyPresentation.editable`).
   */
  editable: boolean;
  // Whether this property supports filtering
  filterable: boolean;
  // Filter operations allowed on this property (empty = use defaults by type)
  filterOperations: FilterOperation[];
  /**
   * The values this field may take, with their labels — a schema fact, not a filter setting. The
   * filter offers them, the table and the edit dialog show their labels.
   */
  allowedValues: FilterOption[];
  // Key dropdown for json filter fields; a key's own `values` are offered once it is picked
  filterJsonKeys: FilterOption[];

  getTranslationKey(): string;

  nameAsString(): string;
}

export class IrdPropertyImpl<T, O> implements IrdProperty<T, O> {
  public daoName?: string;
  public validator: IrdValidator[] = [];
  public asyncValidator: IrdValidator[] = [];
  public parser?: IrdParser;
  public showInUi: boolean = true;
  public array: boolean = false;
  public editable: boolean = true;
  public filterable: boolean = false;
  public filterOperations: FilterOperation[] = [];
  public allowedValues: FilterOption[] = [];
  public filterJsonKeys: FilterOption[] = [];
  private static regexPatternToMatchCamelCase: RegExp = /([a-z0-9])([A-Z])/g;
  private static camelToSnakeReplacePattern: string = '$1_$2';

  constructor(
    public readonly name: keyof T,
    public readonly type: IrdPropertyType,
    private translationKeyPrefix: string,
  ) {}

  public getTranslationKey(): string {
    return this.translationKeyPrefix + '.' + this.getNameInUpperSnakeCaseFormat();
  }

  public nameAsString(): string {
    return this.name.toString();
  }

  private getNameInUpperSnakeCaseFormat(): string {
    return this.nameAsString()
      .replace(IrdPropertyImpl.regexPatternToMatchCamelCase, IrdPropertyImpl.camelToSnakeReplacePattern)
      .toUpperCase();
  }
}
